import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {CommonModule} from "@angular/common";
import {Annexe} from '../../../../models/annexes/AnnexeBody';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-document-view-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './document-view-dialog.component.html',
  styleUrl: './document-view-dialog.component.scss'
})
export class DocumentViewDialogComponent {
  safeDocLink: SafeResourceUrl;
  isPdf = false;
  docTitle: string ='';

  constructor(
    public dialogRef: MatDialogRef<DocumentViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { annexe: Annexe },
    private sanitizer: DomSanitizer
  ) {
    this.isPdf = this.data.annexe.docLink.includes('.pdf');
    this.safeDocLink = this.sanitizer.bypassSecurityTrustResourceUrl(data.annexe.docLink);
    this.docTitle = this.data.annexe.titre.replace(/\.[^/.]+$/, '');
  }

  close(): void {
    this.dialogRef.close();
  }
}
